<template>
  <div class="postEdit" v-loading="loading">
    <div style="width: 980px;overflow: scroll;overflow-x:hidden;height: 600px ">
      <div class="wrap">
        <div class="title">任务信息</div>
        <div class="content">
          <el-row class="formSty">
            <div class="formArea">
            <span class="formLabel">
              <span class="required">* </span>任务名称</span>
              <el-input v-model="jobInformation.jobName" @blur="checkValue(jobInformation.jobName,'任务名称')"
                        size="mini" class="formInpWid" placeholder="请输入任务名称..."></el-input>
            </div>
            <div class="formArea">
              <span class="formLabel">
                <span class="required">* </span>性别要求</span>
                <el-select v-model="jobInformation.sex" size="mini"
                           @change="checkValue(jobInformation.sex,'性别要求')" class="formInpWid"
                           placeholder="请选择..." :clearable="false">
                  <el-option v-for="item in sexOptions" :key="item.id" :label="item.sex"
                             :value="item.sex">
                  </el-option>
                </el-select>
              </div>
          </el-row>
          <el-row class="formSty">
            <div class="formArea" style="width: 100%">
            <span class="formLabel">
              <span class="required">* </span>任务说明</span>
              <div style="float: right;width: 90%;">
              <label v-for="(item,index) in taskInstructionsSigns1" v-bind:key="index" style="font-size:14px;color:#606266;line-height:27px;padding-right:30px;">
                <input type="checkbox" :value="item" v-model="taskInstructionsSigns1V" style="vertical-align:middle;width:16px;height:16px;margin-right:10px;"
                @change="checkBoxValue(item,'任务说明')">{{item}}
              </label>
              </div>
              <label style="font-size:14px;color:#8B8D91;line-height:27px;padding-right:15px;margin-left: 10%;float: left;">
                {{jobInformation.jobDescription}}
              </label>
              <el-input v-if="taskInstructionsSigns1V.includes('其他')" type="textarea" v-model="jobInformation.otherPosDetail" placeholder="请输入其他说明" :maxlength="500" style="margin: 10px 0 0 92px; width: calc(5% - 150px)"></el-input>
            </div>
          </el-row>
          <el-row class="formSty">
            <div class="formArea" style="width: 100%">
            <span class="formLabel">
              <span class="required">* </span>任务要求</span>
              <div style="float: right;width: 90%;">
              <label v-for="(item,index) in taskInstructionsSigns2" v-bind:key="index" style="font-size:14px;color:#606266;line-height:27px;padding-right:30px;">
                <input type="checkbox" :value="item" v-model="taskInstructionsSigns2V" style="vertical-align:middle;width:16px;height:16px;margin-right:10px;"
                @change="checkBoxValue(item,'任务要求')">{{item}}
              </label>
              </div>
              <label style="font-size:14px;color:#8B8D91;line-height:27px;padding-right:15px;margin-left: 10%;float: left;">
                {{jobInformation.jobRequirements}}
              </label>
              <el-input v-if="taskInstructionsSigns2V.includes('其他')" type="textarea" v-model="jobInformation.otherRequirements" placeholder="请输入其他要求" :maxlength="500" style="margin: 10px 0 0 92px; width: calc(100% - 150px)"></el-input>
            </div>
          </el-row>
          <el-row class="formSty">
            <div class="formArea" style="width: 100%">
            <span class="formLabel">
              <span class="required">* </span>服务费说明</span>
              <div style="float: right;width: 90%;">
              <label style="font-size:14px;color:#8B8D91;line-height:27px;padding-right:15px;">
                {{jobInformation.salaryTreatment}}
              </label>
              </div>
            </div>
          </el-row>
          <el-row class="formSty">
            <div class="formArea">
            <span class="formLabel">
                <span class="required">* </span>联系人姓名</span>
                <el-input v-model="jobInformation.supervisorName"
                          @blur="checkValue(jobInformation.supervisorName,'督导姓名')" size="mini"
                          class="formInpWid" placeholder="联系人姓名..."></el-input>
            </div>
            <div class="formArea">
              <span class="formLabel">
                <span class="required">* </span>联系人电话</span>
                <el-input v-model.number="jobInformation.supervisorTel"
                          @blur="checkValue(jobInformation.supervisorTel,'督导电话')" :maxlength="11"
                          size="mini" class="formInpWid" placeholder="联系人电话..."></el-input>
              </div>
          </el-row>

          <!-- <el-row class="formSty">
            <div class="formArea">
              <span class="formLabel">
                <span class="required">* </span>联系人方式</span>
              <el-input v-model.number="jobInformation.contactMethod" @blur="checkValue(jobInformation.contactMethod,'联系人方式')" :maxlength="11" size="mini" class="formInpWid" style="width:77%" placeholder="请输入联系人电话，供促销员咨询沟通..."></el-input>

              <span class="formLabel">
                <span class="required">* </span>档期类型</span>
              <el-select v-model="jobInformation.dateType"
                         @change="checkValue(jobInformation.dateType,'档期类型')" size="mini" class="formInpWid"
                         style="width:77%" placeholder="请选择..." :clearable="false">
                <el-option v-for="item in dateTypeOptions" :key="item.id" :label="item.masterName"
                           :value="item.masterName">
                </el-option>
              </el-select>
            </div>
          </el-row> -->
        </div>
      </div>

      <div class="wrap plan">
        <div class="title">任务设置</div>
        <div class="content">
          <el-row class="formSty">
            <!-- <div class="half">
              <div class="formInp">
              <span class="formLabel">
                <span class="required">* </span>计划人数</span>
                <el-input v-model="plan.number" size="mini" class="formInpWid" placeholder="请输入计划人数"
                          @blur="checkValue(plan.number,'计划人数')" disabled></el-input>
              </div>
              <div class="formInp">
              <span class="formLabel">
                <span class="required">* </span>招聘人数</span>
                <el-input v-model="plan.applyNumber" size="mini" class="formInpWid" placeholder="请输入招聘人数"
                          @blur="checkValue(plan.applyNumber,'招聘人数')" disabled></el-input>
              </div>
            </div> -->
            <div class="half">
              <div class="formInp">
              <span class="formLabel">
                <span class="required">* </span>开始时间</span>
                <el-date-picker v-model="plan.startTime" type="date" placeholder="选择日期"
                                value-format="yyyy-MM-dd" :editable='false' :clearable='false'>
                </el-date-picker>
              </div>
              <div class="formInp">
              <span class="formLabel">
                <span class="required">* </span>结束时间</span>
                <el-date-picker v-model="plan.endTime" type="date" placeholder="选择日期"
                                value-format="yyyy-MM-dd" :editable='false' :clearable='false'>
                </el-date-picker>
              </div>
            </div>
          </el-row>
          <!-- <el-row>
            <div class="formInp" style="width:100%;">
            <span class="formLabel">
              备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注</span>
              <el-input v-model="plan.Remarks" @blur="checkValue(jobInformation.jobName,'岗位名称')" size="mini"
                        class="formInpWid" placeholder="请输入备注信息..." style="width:90%"></el-input>
            </div>
          </el-row> -->
        </div>
      </div>

      <div class="wrap">
        <div class="title">推送设定</div>
        <div class="content">
          <el-row>
            <el-col :span="3">
              <b style="line-height: 30px">已选择标签：</b>
            </el-col>
            <el-col :span="21">
            <span class="already-btn" v-if="array1.length > 0">行业品类:
              <span v-for="(item,index) in array1" :key="item.id">{{item.signName}}
                <span v-if="index != (array1.length - 1)">、</span>
              </span>
            </span>
              <span class="already-btn" v-if="array2.length > 0">岗位类型:
              <span v-for="(item,index) in array2" :key="item.id">{{item.signName}}
                <span v-if="index != (array2.length - 1)">、</span>
              </span>
            </span>
              <span class="already-btn" v-if="array3.length > 0">自我标签:
              <span v-for="(item,index) in array3" :key="item.id">{{item.signName}}
                <span v-if="index != (array3.length - 1)">、</span>
              </span>
            </span>
            </el-col>
          </el-row>
        </div>
      </div>
      <!--180713铎哥说用户还没想好这块怎么做，所以先隐藏掉。粉丝会员可见的数据读取过来的时候(this.getData())被强制转换成全选，其他未修改，逻辑未注释掉-->
      <!--另外还有发布岗位第一页和第二页里面有可见范围设定，也都已经注掉-->
      <!--<div class="wrap">
        <div class="title">可见范围修改 <span style="opacity:0">{{num}}</span></div>
        <div class="content">
          <el-row>
            <div class="common-box-body">
              <el-col :span="8" style="margin-top:3px;">
                <span class="formLabel" style="text-align: left;width:50px">星级</span>
                <el-select v-model="jobInformation.starRating" size="mini" class="rangeSetting1"
                           placeholder="请选择..." @change="num++">
                  <el-option v-for="item in starRatingOptions" :key="item.id" :label="item.rankName"
                             :value="item.rankName">
                  </el-option>
                </el-select>
                <span
                    style="width:90px;text-align: left;font-size: 14px;color: #606266;position:relative;top:2px;left:5px">级别级以上</span>
              </el-col>
              <el-col :span="8" style="margin-top:3px;">
                <span class="formLabel pad20" style="width:90px">信用分值下限</span>
                <el-input v-model="jobInformation.scoreIntervalStart" size="mini" class="rangeSetting"
                          placeholder="分"
                          @blur="checkValue(jobInformation.scoreIntervalStart,'分值下限')"></el-input>
                &lt;!&ndash;上限先注释掉
                —
                <el-input v-model="jobInformation.scoreIntervalEnd" size="mini" class="rangeSetting" placeholder="分" @blur="checkValue(jobInformation.scoreIntervalEnd,'endScore')"></el-input>&ndash;&gt;
              </el-col>
              <el-col :span="8" style=";margin-top:3px;">
                &lt;!&ndash; <el-radio-group v-model="jobInformation.visable" style="margin-top:5px">
                  <el-radio :label="1">粉丝可见</el-radio>
                  <el-radio :label="2">会员可见</el-radio>
                </el-radio-group> &ndash;&gt;
                <span class="formLabel"><span class="required">* </span>账号身份：</span>
                &lt;!&ndash;<span class="required" style="margin-top:5px;">* </span>&ndash;&gt;
                <el-checkbox-group v-model="jobInformation.visable"
                                   style="width:60%;display:inline-block;">
                  <el-checkbox label="粉丝" @change="aaa"></el-checkbox>
                  <el-checkbox label="会员" @change="aaa" style="margin-left: 20px"></el-checkbox>
                </el-checkbox-group>
              </el-col>
            </div>
          </el-row>
        </div>
      </div>-->
    </div>

    <div style="text-align:center">
      <el-button type="text" class="reset-btn" @click="cancel">取消</el-button>
      <el-button class="search-btn" @click="submit">确定</el-button>
      <el-button class="search-btn" @click="alignSubmit">再次推送</el-button>
    </div>

    <el-dialog title="推送管理" class="quitDialog dialog postEditManagement" width="1000px" :center="true"
               :show-close="false"
               :visible.sync="innerVisible" append-to-body v-loading="posLoading">
      <h4>推送设定</h4>
      <div class="body">
        <el-row>
          <el-col :span="4">
            <el-checkbox v-model="checkedPromoters">指定促销员推送</el-checkbox>
          </el-col>
          <el-col :span="6">
            <el-button class="clickSign pointer" @click="choosePromoters" v-show="checkedPromoters">选择促销员</el-button>
          </el-col>

        </el-row>
        <el-row v-show="checkedPromoters">
          <el-col :span="3">
            <b>已选择促销员：</b>
          </el-col>
          <el-col :span="21">
            <span class="already-btn" v-for="(item,index) in isckeckPromotersList" :key="index"> {{item.name}}
              <span class="remove-btn pointer" @click="deleteLabel(index)"></span>
            </span>
          </el-col>
        </el-row>
      </div>
      <div class="body">
        <el-row>
          <el-col :span="4">
            <el-checkbox v-model="checkedSign">标签推送</el-checkbox>
          </el-col>
          <el-col :span="6">
            <el-button class="clickSign pointer" @click="chooseSign" v-show="checkedSign">选择标签</el-button>
          </el-col>
        </el-row>
        <el-row v-show="checkedSign">
          <el-col :span="3">
            <b>已选择标签：</b>
          </el-col>
          <el-col :span="21">
            <span class="already-btn" v-for="(item,index) in SignArr.array_1" :key="item.id">
              <span v-if="item.signName != '不限'"> {{item.signName}}</span>
              <span v-else> 行业品类：不限</span>
              <span class="remove-btn pointer" @click="removeSignLabel(index,1)"></span>
            </span>
            <span class="already-btn" v-for="(item,index) in SignArr.array_2" :key="item.id">
              <span v-if="item.signName != '不限'"> {{item.signName}}</span>
              <span v-else> 岗位类型：不限</span>
              <span class="remove-btn pointer" @click="removeSignLabel(index,2)"></span>
            </span>
            <span class="already-btn" v-for="(item,index) in SignArr.array_3" :key="item.id">
              <span v-if="item.signName != '不限'"> {{item.signName}}</span>
              <span v-else> 自我标签：不限</span>
              <span class="remove-btn pointer" @click="removeSignLabel(index,3)"></span>
            </span>
          </el-col>
        </el-row>
      </div>
      <div style="text-align:center;margin-top:30px;">
        <el-button type="text" class="reset-btn" @click="innerVisible=false">取消</el-button>
        <el-button class="search-btn" @click="levelTwoSubmit">推送</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加促销员" class="quitDialog dialog PromotersDialog" width="1000px" :center="true"
               :show-close="false" :visible.sync="innerVisible2" append-to-body :close-on-click-modal='false'>

      <el-row style="margin-bottom:10px">
        <b>已选择促销员:</b>
        <span class="already-btn" v-for="(item,index) in isckeckPromotersList2" :key="index"> {{item.name}}
          <span class="remove-btn pointer" @click="deleteLabel2(index)"></span>
        </span>
      </el-row>
      <el-row style="margin-bottom:10px">
        <el-col :span='5'>
          <span class="formLabel ">姓名</span>
          <el-input v-model="PromotersPopUp.name" size="mini" class="formInpWid" placeholder="请输入..."
                    :maxlength="10"></el-input>
        </el-col>
        <el-col :span='7'>
          <span class="formLabel ">身份证号</span>
          <el-input v-model="PromotersPopUp.idCard" size="mini" class="formInpWid" style="width:65%"
                    placeholder="请输入..." :maxlength="19" @change="checkIdCard"></el-input>
        </el-col>
        <el-col :span='5'>
          <span class="formLabel" style="width:50px;">年龄</span>
          <el-input v-model.number="PromotersPopUp.minAge" size="mini" class="rangeSettingAge" placeholder="岁"
                    :maxlength="3"></el-input>
          —
          <el-input v-model.number="PromotersPopUp.maxAge" size="mini" class="rangeSettingAge" placeholder="岁"
                    :maxlength="3"></el-input>
        </el-col>
        <el-col :span='5'>
          <span class="formLabel" style="width:50px;">身高</span>
          <el-input v-model.number="PromotersPopUp.minHeight" size="mini" class="rangeSettingAge"
                    placeholder="CM" :maxlength="3"></el-input>
          —
          <el-input v-model.number="PromotersPopUp.maxHeight" size="mini" class="rangeSettingAge"
                    placeholder="CM" :maxlength="3"></el-input>
        </el-col>
      </el-row>
      <el-row style="margin-bottom: 5px;">
        <el-col :span='7'>
          <span class="formLabel ">促销员编号</span>
          <el-input v-model="PromotersPopUp.empCode" size="mini" class="formInpWid" style=""
                    placeholder="请输入..." :maxlength="50"></el-input>
        </el-col>
        <el-col :span='2'>
          <div class="search" @click="searchSaleManInfo('doNotJump')">
            筛选
          </div>
        </el-col>
      </el-row>

      <div class="tableBackGround">
        <el-table class="limitManagerTable table-expand" style="width: 100%" :data="tableData" size="small"
                  border header-row-class-name="table-header" v-loading="tableLoading" @select="selectChange"
                  @select-all="selectAllChange" ref="salesmuli">
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" width="50" label="编号" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column prop="empCode" label="促销员编号" align="center"></el-table-column>
          <el-table-column prop="idCard" label="身份证号" align="center"
                           :formatter="formatIdCard"></el-table-column>
          <el-table-column prop="tel" label="手机号" align="center" :formatter="formatTel"></el-table-column>
          <el-table-column prop="age" label="年龄" align="center"></el-table-column>
          <el-table-column prop="height" label="身高" align="center"></el-table-column>
        </el-table>
        <div style="width:60%;margin:0 auto;">
          <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                         @current-change="handleCurrentChange" :current-page="PromotersPopUp.pageNo"
                         :page-sizes="[10, 20, 30, 40]" :page-size="PromotersPopUp.pageSize"
                         :total="PromotersPopUp.total" layout="total,prev, pager, next, jumper">
          </el-pagination>
        </div>
      </div>

      <div style="text-align:center;margin-top:30px;">
        <el-button type="text" class="reset-btn" @click="changeInnerVisible2">取消</el-button>
        <el-button class="search-btn" @click="sureSaleMan">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加标签" class="quitDialog dialog" width="1000px" :center="true" :show-close="false"
               :visible.sync="innerVisible3" append-to-body :close-on-click-modal='false'>
      <el-row style="margin-bottom:10px;margin-top:10px;">
        <el-col :span="2">
          <span>您已选择</span>
        </el-col>
        <el-col :span="22">
          <span class="already-btn" v-if="SignArr2.array_1.length > 0">行业品类:
            <span v-for="(item,index) in SignArr2.array_1" :key="item.id">{{item.signName}}
              <span v-if="index != (SignArr2.array_1.length - 1)">、</span>
            </span>
            <span class="remove-btn pointer" @click="removeArray(1)"></span>
          </span>
          <span class="already-btn" v-if="SignArr2.array_2.length > 0">岗位类型:
            <span v-for="(item,index) in SignArr2.array_2" :key="item.id">{{item.signName}}
              <span v-if="index != (SignArr2.array_2.length - 1)">、</span>
            </span>
            <span class="remove-btn pointer" @click="removeArray(2)"></span>
          </span>
          <span class="already-btn" v-if="SignArr2.array_3.length > 0">自我标签:
            <span v-for="(item,index) in SignArr2.array_3" :key="item.id">{{item.signName}}
              <span v-if="index != (SignArr2.array_3.length - 1)">、</span>
            </span>
            <span class="remove-btn pointer" @click="removeArray(3)"></span>
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <span>行业品类</span>
        </el-col>
        <el-col :span="20" class="signWrap" style="overflow: hidden;">
          <div class="signList pointer" :class="{'active' : item.choose}" @click="hangYeChoose(item)"
               v-for="(item,index) in SignPopUp.tabsData" :key="item.id">{{item.signName}}
          </div>
        </el-col>
        <el-col :span="2" style="position:relative">
          <div class="toggle-btn" @click="toggleSlide"></div>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="2">
          <span>岗位类型</span>
        </el-col>
        <el-col :span="20" class="signWrap" style="overflow: hidden;">
          <div class="signList pointer" :class="{'active' : item.choose}" @click="gangWeiChoose(item)"
               v-for="(item,index) in SignPopUp.tabsData2" :key="item.id">{{item.signName}}
          </div>
        </el-col>
        <el-col :span="2" style="position:relative">
          <div class="toggle-btn" @click="toggleSlide"></div>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="2">
          <span>自我标签</span>
        </el-col>
        <el-col :span="20" class="signWrap" style="overflow: hidden;">
          <div class="signList pointer" :class="{'active' : item.choose}" @click="biaoQianChoose(item)"
               v-for="(item,index) in SignPopUp.tabsData3" :key="item.id">{{item.signName}}
          </div>
        </el-col>
        <el-col :span="2" style="position:relative">
          <div class="toggle-btn" @click="toggleSlide"></div>
        </el-col>

      </el-row>

      <div style="text-align:center;margin-top:30px;">
        <el-button type="text" class="reset-btn" @click="changeInnerVisible3">取消</el-button>
        <el-button class="search-btn" @click="sureSignLabel">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import utils from '../../common/js/util.js'

  export default {
    data() {
      return {
        num: 1,
        dataList: null,
        workPosId: null,
        //编辑页信息
        jobInformation: {
          jobName: null,
          jobType: null,
          serviceObj: null,
          dateType: null,
          jobDescription: null,
          salaryTreatment: null,
          sex: null,
          salarySettlement: null,
          salary: null,
          visable: [],
          monthSalary: '',
          otherPosDetail : '', // 其他任务说明
          otherRequirements: '' // 其他任务要求
        },
        proStartTime: '',//岗位绑定的项目的起止时间，仅用作比较
        proEndTime: '',
        //工作类型
        jobTypeOptions: [
          {id: 0, jobType: "不限"},
          {id: 1, jobType: "长促"},
          {id: 2, jobType: "短促"}
        ],
        dateTypeOptions: [],//档期类型
        //性别
        sexOptions: [
          {id: 0, sex: "不限"},
          {id: 1, sex: "男"},
          {id: 2, sex: "女"}
        ],
        salarySettlementOptions: [],
        //计划人数
        plan: {
          number: null,
          applyNumber: null,
          startTime: null,
          endTime: null,
          Remarks: null
        },
        starRatingOptions: [],
        //再次推送弹窗
        innerVisible: false,
        //添加促销员弹窗
        innerVisible2: false,
        //添加标签弹窗
        innerVisible3: false,
        //制定促销员推送
        checkedPromoters: false,
        //指定标签推送
        checkedSign: false,
        //已选择得促销员
        PromotersArr: [],
        /*
        以下是标签相关，一共3级
        */
        //已选择的标签-1级
        //已选择行业品类
        array1: [],
        //已选择岗位类型
        array2: [],
        //已选择自我标签
        array3: [],
        //已选择标签--2级
        SignArr: {
          array_1: [],
          array_2: [],
          array_3: [],
        },
        //已选择标签-3级
        SignArr2: {
          array_1: [],
          array_2: [],
          array_3: [],
        },
        //所有的标签，用作map对照，同时也作为-3级页的展示和choosen
        SignPopUp: {
          checkboxGroup: [],
          //行业品类
          tabsData: [],
          //岗位类型
          tabsData2: [],
          //自我标签
          tabsData3: []
        },
        onceTime: true,//chooseSign方法中，作为只执行一次的函数的标志位
        /*
        以上是标签相关，一共3级
        */
        //添加促销员筛选项
        PromotersPopUp: {
          name: null,
          idCard: null,
          minAge: null,
          maxAge: null,
          minHeight: null,
          maxHeight: null,
          empCode: null,
          pageNo: 1,
          pageSize: 10,
          total: null
        },
        //添加促销员表格
        tableData: [],

        judgeInterview: null, //首页岗位薪水可修改状态
        storeCode: null, //storecode
        loading: false,//编辑岗位页loading
        posLoading: false,//推送管理页loading
        tableLoading: false,//推送管理-选择促销员页的tableloading
        isckeckPromotersList: [],//选择的促销员-2级
        isckeckPromotersList2: [],//选择的促销员-3级
        bluring: false,
        hasError: false,//和bluring一起，确保两轮校验不冲突且不遗漏
        planHasError: false,//和bluring一起，确保两轮校验不冲突且不遗漏
        infoHasError: false,//和bluring一起，确保两轮校验不冲突且不遗漏
        dataReady: {
          getIndustryLabel: false,
          getJobLabel: false,
          getSelfLabel: false,
          searchMasterName1: false,
          searchMasterName2: false,
          searchRankRuleName: false,
          searchJudgeInterview: false,
        },

        taskInstructionsSigns1: [],//任务说明
        taskInstructionsSigns1V:[],
        taskInstructionsSigns2: [],//任务要求
        taskInstructionsSigns2V:[],
      };
    },
    props: ["Child"],
    mounted() {
      this.getIndustryLabel();// 获取行业类型二级标签
      this.getJobLabel();// 获取岗位标签
      this.getSelfLabel()// 获取自我标签
      this.searchMasterName1();//获取档期类型数据
      this.searchMasterName2();//获取结算方式数据
      this.searchRankRuleName();//获取星级
      this.searchJudgeInterview()//获取是否可以编辑
      //由于getdata会用到前面几个请求的数据，可能还没回调呢，getdata就开始执行了
      //所以加了个watch，只有前面4个同时执行完毕后才调用getdata

      this.getTaskInstructionsSigns();
      this.getTaskInstructionsSigns2();
    },
    methods: {
      //删掉会报错。。。。。
      aaa() {
      },
      //工具类，弹框简写
      myNotify(_this, type, normal, or) {
        utils.myNotify(_this, type, normal, or)
      },
      //工具类，把数据转换成传输用的id形式
      transDataToId(which) {
        var toId = {};
        //把档期类型转换为id格式
        if (which.scheduleType) {
          this.dateTypeOptions.map(item => {
            if (item.masterName == this.jobInformation.dateType) {
              toId.scheduleType = item.id;
            }
          })
        }
        //把可见范围星级转换为id格式
        if (which.rankRuleId) {
          this.starRatingOptions.map(item => {
            if (item.rankName == this.jobInformation.starRating) {
              toId.rankRuleId = item.id;
            }
          });
        }
        //把岗位类型转换为id格式(长短促)
        if (which.signId) {
          this.jobTypeOptions.map(item => {
            if ((this.jobInformation.jobType == item.signName)) {
              toId.signId = item.id;
            }
          });
        }
        //把性别要求转换为id格式
        if (which.sex) {
          this.sexOptions.map(item => {
            if ((this.jobInformation.sex == item.sex)) {
              toId.sex = item.id;
            }
          });
        }
        //把结算方式周期转换为id格式
        if (which.salaryCycle) {
          this.salarySettlementOptions.map(item => {
            if ((this.jobInformation.salarySettlement == item.masterName)) {
              toId.salaryCycle = item.id;
            }
          });
        }
        //把可见范围-粉丝会员转换为id格式
        if (which.searchType) {
          if (this.jobInformation.visable.length == 2) {
            toId.searchType = 0
          } else if (this.jobInformation.visable.length == 0) {
            toId.searchType = ''
          } else if (this.jobInformation.visable.length == 1) {
            if (this.jobInformation.visable[0] == "粉丝") {
              toId.searchType = 1
            } else if (this.jobInformation.visable[0] == "会员") {
              toId.searchType = 2
            }
          }
        }
        //
        return toId
      },
      //工具类-blur时校验岗位信息
      checkValue(val, type) {
        this.bluring = true;
        setTimeout(() => {
          this.bluring = false;
        }, 100)
        let errMsg = "";
        switch (type) {
          //case '任务名称' || '项目客户' || '任务说明' || '薪资待遇' || '岗位福利' || '岗位要求':
          case '任务名称':
          if (utils.bool(val)) {
              errMsg = `请输入${type}`
            }
            break;
          case '督导电话' :
            if (utils.bool(val)) {
              errMsg = `请输入联系人方式`
            } else if (isNaN(val)) {
              errMsg = "请输入数字类型!";
            } else if (!(/^1[345789]\d{9}$/.test(val)) && !(/^0[0-9]{2,3}\-([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/).test(val)) {
              errMsg = "请输入正确的电话号!";
            }
            break;
          case "联系人方式":
            //跟督导电话一样，但现在不用了
            break;
          case "计划人数" || "招聘人数":
            if (isNaN(val)) {
              errMsg = "请输入数字类型!";
            } else if (val < 0) {
              errMsg = "请输入正确的人数!";
            }
            break;
          case "分值下限" || '岗位薪水':
            if (val < 0) {
              errMsg = `${type}不可以小于0!`
            } else if (isNaN(val)) {
              errMsg = "请输入数字类型!";
            }
            /*        关于区间上限的判断暂时不需要
            else if (
              this.jobInformation.scoreIntervalEnd != null &&
              this.jobInformation.scoreIntervalEnd != "" &&
              this.jobInformation.scoreIntervalEnd != undefined
            ) {
              if (val > this.jobInformation.scoreIntervalEnd) {
                errMsg = "分值区间有误!";
              }
            }*/
            break;
          /*      上限分值的判断暂时不需要
          else if (type == "endScore") {
            if (val == null || val == "" || val == undefined) {
              errMsg = `请输入分值!`;
            } else if(isNaN(val)){
              errMsg = "请输入数字类型!";
            } else if(this.jobInformation.scoreIntervalEnd < 0){
              errMsg = `分值区间不可以小于0!`
            } else if (
              this.jobInformation.scoreIntervalStart != null &&
              this.jobInformation.scoreIntervalStart != "" &&
              this.jobInformation.scoreIntervalStart != undefined
            ) {
              if (val < this.jobInformation.scoreIntervalStart) {
                errMsg = "分值区间有误!";
              }
            }
          }*/
        }
        // console.log('checkValue_errMsg',errMsg)
        if (errMsg != "") {
          this.myNotify(this, 'warning', errMsg)
          this.hasError = true;
        } else {
          this.hasError = false;
        }
      },
      //工具类-校验招聘设置表单
      checkPlans(plan) {
        let errMsg = "";
        if (utils.bool(plan.number)) {
          errMsg = "请填写计划人数";
        } else if (plan.number < 0) {
          errMsg = "计划人数不能小于0";
        } else if (isNaN(plan.number)) {
          errMsg = "计划人数请填写数字";
        } else if (utils.bool(plan.applyNumber)) {
          errMsg = "请填写招聘人数";
        } else if (plan.applyNumber < 0) {
          errMsg = "招聘人数不能小于0";
        } else if (isNaN(plan.applyNumber)) {
          errMsg = "招聘人数请填写数字";
        } else if (utils.bool(plan.startTime)) {
          errMsg = "请填写开始时间";
        } else if (utils.bool(plan.endTime)) {
          errMsg = "请填写结束时间";
        } else if (new Date(plan.startTime).getTime() > new Date(plan.endTime).getTime()) {
          errMsg = "开始时间应小于结束时间";
        } else {
          let time = {
            proStartT: new Date(this.proStartTime).getTime(),
            proEndT: new Date(this.proEndTime).getTime(),
            publishStart: new Date(this.plan.startTime).getTime(),
            publishEnd: new Date(this.plan.endTime).getTime(),
          }
          if (time.publishEnd < time.publishStart) {
            errMsg = '开始时间应小于结束时间'
          } else if (time.publishEnd > time.proEndT) {
            errMsg = '岗位结束时间应在项目时间范围内'
          } else if (time.publishStart < time.proStartT) {
            errMsg = '岗位开始时间应在项目时间范围内'
          }
        }

        if (errMsg != "") {
          this.myNotify(this, 'warning', errMsg)
          this.planHasError = true;
        } else {
          this.planHasError = false;
        }
      },
      //工具类-检验岗位信息表单
      checkValues(jobInfo) {
        let errMsg = "";
        if (utils.bool(jobInfo.jobName)) {
          errMsg = "请输入任务名称";
        } else if (utils.bool(jobInfo.jobType)) {
          errMsg = "请选择岗位类型";
        // } else if (utils.bool(jobInfo.serviceObj)) {
        //   errMsg = "请输入项目客户";
        // } else if (utils.bool(jobInfo.dateType)) {
        //   errMsg = "请选择档期类型";
        } else if (utils.bool(jobInfo.jobDescription)) {
          errMsg = "请输入任务说明";
        // } else if (utils.bool(jobInfo.salaryTreatment)) {
        //   errMsg = "请输入薪资待遇";
        // } else if (utils.bool(jobInfo.postWelfare)) {
        //   errMsg = "请输入岗位福利";
        } else if (utils.bool(jobInfo.jobRequirements)) {
          errMsg = "请输入任务要求";
        // } else if (utils.bool(jobInfo.salary)) {
        //   errMsg = "请选择岗位薪水";
        // } else if (utils.bool(jobInfo.monthSalary) && this.jobInformation.salary != 3) {
        //   errMsg = "请填写岗位薪水";
        // } else if (isNaN(jobInfo.monthSalary) || jobInfo.monthSalary < 0) {
        //   errMsg = "请输入正确岗位薪水"
        // } else if (utils.bool(jobInfo.salarySettlement)) {
        //   errMsg = "请选择结算方式";
        } else if (utils.bool(jobInfo.sex)) {
          errMsg = "请选择性别要求";
        } else if (utils.bool(jobInfo.supervisorName)) {
          errMsg = "请输入联系人姓名";
        } else if (utils.bool(jobInfo.supervisorTel)) {
          errMsg = "请输入联系人电话";
        } else if (isNaN(jobInfo.supervisorTel)) {
          errMsg = "请输入数字类型!";
        } else if (!(/^1[345789]\d{9}$/.test(jobInfo.supervisorTel)) && !(/^0[0-9]{2,3}\-([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/).test(jobInfo.supervisorTel)) {
          errMsg = "请输入正确的电话号!";
        }/* else if (utils.bool(jobInfo.contactMethod)        ) {
          errMsg = "请输入联系人方式";
        } else if (typeof jobInfo.contactMethod !== "number") {
          errMsg = "请输入数字类型!";
        } else if (!/^1[34578]\d{9}$/.test(jobInfo.contactMethod)) {
          errMsg = "请输入正确的电话号!";
        } */ /*else if (utils.bool(jobInfo.scoreIntervalStart)/!*||utils.bool(jobInfo.scoreIntervalEnd)*!/) {
          errMsg = "请输入分值";
        } */ else if (isNaN(jobInfo.scoreIntervalStart) || jobInfo.scoreIntervalStart < 0 /*||isNaN(jobInfo.scoreIntervalEnd)*/) {
          errMsg = "请输入正确的分值";
        } else if (!this.jobInformation.visable || this.jobInformation.visable.length == 0) {
          errMsg = '请选择粉丝可见或会员可见！'
        } else if (jobInfo.jobDescription.split(';').includes('其他') && !jobInfo.otherPosDetail) {
          errMsg = '请填写任务说明！'
        } else if (jobInfo.jobRequirements.split(';').includes('其他') && !jobInfo.otherRequirements) {
          errMsg = '请填写任务要求！'
        }
        /* else if (        jobInfo.scoreIntervalStart > jobInfo.scoreIntervalEnd      ) {
          errMsg = "分值区间有误!";
        }*/
        // console.log('checkValues_errMsg',errMsg)
        if (errMsg != "") {
          this.myNotify(this, 'warning', errMsg)
          this.infoHasError = true;
        } else {
          this.infoHasError = false;
        }
      },
      //工具类-再次推送-选择促销员-检查身份证
      checkIdCard() {
        var re = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
        if (re.test(this.PromotersPopUp.idCard) == false && this.PromotersPopUp.idCard != "") {
          this.myNotify(this, 'warning', '请输入正确身份证号')
        }
      },
      //工具类-身份证号格式化
      formatIdCard(row, column, cellValue) {
        return utils.plusXing(cellValue, 6, 4)
      },
      //工具类-电话号码格式化
      formatTel(row, column, cellValue) {
        return utils.plusXing(cellValue, 3, 4)
      },

      //getData方法专用：去除loading
      stopLoading(x) {
        if (x.findWorkSign && x.moreStoreAndPosMessage) this.loading = false;
      },
      //本组件-获取详细信息
      getData() {
        this.loading = true;
        let x = {
          moreStoreAndPosMessage: false,
          findWorkSign: false,
        }

        //获取标签推送设定
        {
          this.$http({
            method: "GET",
            url: "/rest/PostManagement/findWorkSign",
            params: {
              'workPosId': this.Child[0].workPosId
            }
          }).then(res => {
            //返回一个数组，所有推送的id
            res.data.map(item => {
              if (item == -2) {
                //如果-2的话，说明行业品类选择了不限，这里手动选择一下
                this.SignPopUp.tabsData[0].choose = true
                this.array1.push(this.SignPopUp.tabsData[0])
              } else if (item == -3) {
                //如果-3的话，说明自我标签选择了不限，这里手动选择一下
                this.SignPopUp.tabsData3[0].choose = true
                this.array3.push(this.SignPopUp.tabsData3[0])
              } else {
                //这里可以break或者return提高性能，先不做了
                //map行业品类的总数据，并保存
                this.SignPopUp.tabsData.map(item1 => {
                  if (item == item1.id) {
                    this.array1.push(item1)
                    item1.choose = true
                  }
                })
                //map岗位类型的总数据，并保存
                this.SignPopUp.tabsData2.map(item1 => {
                  if (item == item1.id) {
                    this.array2.push(item1)
                    item1.choose = true
                  }
                })
                //map自我标签的总数据，并保存
                this.SignPopUp.tabsData3.map(item1 => {
                  if (item == item1.id) {
                    this.array3.push(item1)
                    item1.choose = true
                  }
                })
              }
            })
            //强制顺序的代码，没啥别的作用
            x.findWorkSign = true;
            this.stopLoading(x)
          }).catch((err) => {
            x.findWorkSign = true;
            this.stopLoading(x)
            this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          })
        }
        //获取岗位数据
        {
          this.$http({
            method: "GET",
            url: "/rest/PostManagement/moreStoreAndPosMessage",
            params: {
              posStoreId: this.Child[0].posStoreId
            }
          }).then(res => {
            let data = res.data
            this.proStartTime = data.projectStartTime
            this.proEndTime = data.projectEndTime
            this.storeCode = data.storeCode;
            // this.workPosId = data.workPosId;//这里是异步的，不能在这里赋值，下一步操作太快，获取不到数据
            this.jobInformation.jobName = data.posName;
            this.jobInformation.jobDescription = data.posDetail;
            
            this.jobInformation.salaryTreatment = data.salaryDetail;
            this.jobInformation.postWelfare = data.welfareDetail;
            this.jobInformation.jobRequirements = data.requirements;
            // 处理任务说明/任务要求，按';'拆分
            this.anTaskInstructionsSigns(data.posDetail, data.requirements);

            this.jobInformation.supervisorName = data.moName;
            this.jobInformation.supervisorTel = data.moTel;
            this.jobInformation.contactMethod = data.requirementsTel;
            this.jobInformation.monthSalary = data.salary;
            this.jobInformation.otherPosDetail = data.otherPosDetail;
            this.jobInformation.otherRequirements = data.otherRequirements;
            this.plan.number = data.planNumber;
            if (this.plan.number == null) {
              this.plan.number = 0;
            }
            this.plan.applyNumber = data.recruitsNumber;
            this.plan.startTime = data.requirementsStart;
            this.plan.endTime = data.requirementsEnd;
            this.plan.Remarks = data.remark;
            this.jobInformation.scoreIntervalStart = data.crescoreMin;
            // this.jobInformation.scoreIntervalEnd = data.crescoreMax;
            // 180713铎哥说用户还没想好可见范围这块怎么做，所以先隐藏掉
            //这里是必填项会影响到校验和后台可见逻辑，所以强制设置为全选
            this.jobInformation.visable = ['粉丝', '会员']
            // if (data.searchType == 1) {
            //   this.jobInformation.visable = ['粉丝']
            // } else if (data.searchType == 2) {
            //   this.jobInformation.visable = ['会员']
            // } else if (data.searchType == 0) {
            //   this.jobInformation.visable = ['粉丝', '会员']
            // } else {
            //   this.jobInformation.visable = []
            // }
            this.jobInformation.serviceObj = data.customer;

            // this.jobInformation.dateType = data.scheduleType;
            this.salarySettlementOptions.map(item => {
              if (item.id == data.salaryCycle) {
                this.jobInformation.salarySettlement = item.masterName;
              }
            });
            this.dateTypeOptions.map((item, index) => {
              if (item.id == data.scheduleType) {
                this.jobInformation.dateType = item.masterName;
              }
            });
            this.starRatingOptions.map(item => {
              if (item.id == data.rankRuleId) {
                this.jobInformation.starRating = item.rankName
              }
            })
            this.jobTypeOptions.map(item => {
              if (item.id == data.signId) {
                this.jobInformation.jobType = item.signName;
              }
            });
            this.sexOptions.map(item => {
              if (item.id == data.sex) {
                this.jobInformation.sex = item.sex;
              }
            });

            this.jobInformation.salary = String(data.salaryType);

            x.moreStoreAndPosMessage = true
            this.stopLoading(x)
          }).catch(err => {
            this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')

            x.moreStoreAndPosMessage = true
            this.stopLoading(x)
          });
        }
        this.dataList = this.Child[0];
      },
      // 解析任务说明，任务要求字符串变复选框显示问题,v1任务说明，v2任务要求
      anTaskInstructionsSigns(v1, v2) {
        var self = this
        // 处理任务说明，按';'拆分
        var v1A = v1.split(";");
        for(let i in v1A){
          console.log(i,v1A[i])
          for(let j in self.taskInstructionsSigns1) {
            if(v1A[i] === self.taskInstructionsSigns1[j]) {
              self.taskInstructionsSigns1V.push(v1A[i]);
            }
          }
        }
        console.log('1---->>',self.taskInstructionsSigns1V);

        // 处理任务要求，按';'拆分
        var v2A = v2.split(";");
        for(let i in v2A){
          console.log(i,v2A[i])
          for(let j in self.taskInstructionsSigns2) {
            if(v2A[i] === self.taskInstructionsSigns2[j]) {
              self.taskInstructionsSigns2V.push(v2A[i]);
            }
          }
        }
        console.log('2---->>',self.taskInstructionsSigns2V);
      },
      //本组件-点击确定（保存本岗位）
      submit() {
        var idData = this.transDataToId({
          scheduleType: true,
          rankRuleId: true,
          signId: true,
          sex: true,
          salaryCycle: true,
          searchType: true,
        })
        if (!this.hasError || !this.bluring) {
          console.log('进入校验')
          this.jobInformation.jobDescription = this.taskInstructionsSigns1V.join(";")
          this.jobInformation.jobRequirements = this.taskInstructionsSigns2V.join(";")

          this.checkValues(this.jobInformation)
          this.checkPlans(this.plan);
        }

        if (this.hasError || this.infoHasError || this.planHasError) {
          return false
        } else {
          this.loading = true
          this.$http({
            method: "POST",
            url: "/rest/PostManagement/updatePosSTore",
            data: {
              posStoreId: this.dataList.posStoreId,
              workPosId: this.Child[0].workPosId,
              posName: this.jobInformation.jobName,
              signId: idData.signId,
              customer: this.jobInformation.serviceObj,
              scheduleType: idData.scheduleType,
              posDetail: this.jobInformation.jobDescription,
              salaryDetail: this.jobInformation.salaryTreatment,
              welfareDetail: this.jobInformation.postWelfare,
              requirements: this.jobInformation.jobRequirements,
              salaryCycle: idData.salaryCycle,
              salary: this.jobInformation.monthSalary,
              salaryType: Number(this.jobInformation.salary),
              moName: this.jobInformation.supervisorName,
              moTel: this.jobInformation.supervisorTel,
              requirementsTel: this.jobInformation.contactMethod,
              otherPosDetail: this.jobInformation.otherPosDetail,
              otherRequirements: this.jobInformation.otherRequirements,
              searchType: idData.searchType,

              publishUserId: sessionStorage.getItem('sysUserId'),
              rankRuleId: idData.rankRuleId,
              sex: idData.sex,
              // workCode: "string",
              requirementsStart: this.plan.startTime,
              requirementsEnd: this.plan.endTime,
              recruitsNumber: this.plan.applyNumber,
              remark: this.plan.Remarks,

              planNumber: this.plan.number,

              /*crescoreMax: this.jobInformation.scoreIntervalEnd,*/
              crescoreMin: this.jobInformation.scoreIntervalStart
            }
          }).then(res => {
            this.myNotify(this, 'success', '更新成功')
            this.loading = false
            this.$emit('submitForm')//成功后后台数据变了，但页面上的数据不会变更，主动触发父级的‘筛选’按钮事件，以更新视图
            this.$emit("upupup", false); //主动触发upupup方法，'hehe'为向父组件传递的数据
          }).catch(err => {
            this.loading = false
            this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          });
        }
      },
      //本组件-点击再次推送
      alignSubmit() {
        // 点再次推送的时候，从array123获取值
        for (let i = 1; i < 4; i++) {
          this.SignArr['array_' + i] = [];
          this['array' + i].map(item => {
            this.SignArr['array_' + i].push(item)
          })
        }
        // console.log('选中的标签', this.SignArr)
        //推送设定：如果有则自动显示选了啥否则啥也不显示
        this.checkedSign = (this.SignArr.array_1.length != 0 || this.SignArr.array_2.length != 0 || this.SignArr.array_3.length != 0)
        this.checkedPromoters = false
        this.isckeckPromotersList = [];//这里要么第一次进来，要么点了取消再回来，肯定要置空
        //如果blur没发现错误，或者不是blur+click情况
        if (!this.hasError || !this.bluring) {
          this.jobInformation.jobDescription = this.taskInstructionsSigns1V.join(";")
          this.jobInformation.jobRequirements = this.taskInstructionsSigns2V.join(";")

          this.checkValues(this.jobInformation)
          this.checkPlans(this.plan)
        }
        //如果info和plan校验发现错误
        if (this.hasError || this.infoHasError || this.planHasError) {
          return false;
        } else {
          this.innerVisible = true;
        }
      },
      //本组件-点击取消
      cancel() {
        this.$emit("upupup", false); //主动触发upup方法，'hehe'为向父组件传递的数据，意思是从父级关闭本对话框
      },
      // 获取行业类型二级标签-总数据
      getIndustryLabel() {
        this.dataReady.getIndustryLabel = false
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchIndustrySignName',
          params: {
            signType: 1,
            signLevel: 2
          }
        }).then(res => {
          res.data.map(item => {
            item.choose = false
          })
          let data = res.data
          this.SignPopUp.tabsData = data
          //行业品类的不限，后台不给返回，需要自己追加
          this.SignPopUp.tabsData.unshift({
            choose: false,
            id: -2,
            signName: '不限'
          })
          this.dataReady.getIndustryLabel = true
        }).catch((err) => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取岗位标签-总数据
      getJobLabel() {
        this.dataReady.getJobLabel = false
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchSignName',
          params: {
            signType: 2,
          }
        }).then(res => {
          this.jobTypeOptions = res.data;
          res.data.map(item => {
            item.choose = false
          })
          this.SignPopUp.tabsData2 = res.data;
          this.dataReady.getJobLabel = true
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取自我标签-总数据
      getSelfLabel() {
        this.dataReady.getSelfLabel = false
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchSignName',
          params: {
            signType: 3,
          }
        }).then(res => {
          res.data.map(item => {
            item.choose = false
          })
          let data = res.data
          this.SignPopUp.tabsData3 = data
          //后台不会返自我标签的不限，需要自己追加
          this.SignPopUp.tabsData3.unshift({
            choose: false,
            id: -3,
            signName: '不限'
          })
          this.dataReady.getSelfLabel = true
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //获取档期类型-总数据
      searchMasterName1() {
        this.dataReady.searchMasterName1 = false
        this.$http({
          method: "GET",
          url: "/rest/PublishedWork/searchMasterName",
          params: {
            masterCode: "SCHEDULE_TYPE"
          }
        }).then(res => {
          this.dateTypeOptions = res.data;
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
        this.dataReady.searchMasterName1 = true
      },
      //获取结算方式-总数据
      searchMasterName2() {
        this.dataReady.searchMasterName2 = false
        this.$http({
          method: "GET",
          url: "/rest/PublishedWork/searchMasterName",
          params: {
            masterCode: "SALARY_CYCLE"
          }
        }).then(res => {
          this.dataReady.searchMasterName2 = true
          this.salarySettlementOptions = res.data;
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //星级查询-总数据
      searchRankRuleName() {
        this.dataReady.searchRankRuleName = false
        this.$http({
          method: "GET",
          url: "/rest/PublishedWork/searchRankRuleName"
        }).then(res => {
          this.starRatingOptions = res.data;
          this.dataReady.searchRankRuleName = true
        }).catch((err) => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //查看该页薪资部分 是否可修改
      searchJudgeInterview() {
        this.dataReady.searchJudgeInterview = false
        this.$http({
          method: "GET",
          url: "/rest/PostManagement/judgeInterview",
          params: {posStoreId: this.Child[0].posStoreId}
        }).then(res => {
          this.judgeInterview = res.data.message;
          this.dataReady.searchJudgeInterview = true
        }).catch((err) => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },

      //搜索促销员
      searchSaleManInfo(jumpPage) {
        var idData = this.transDataToId({
          // scheduleType:true,
          // rankRuleId:true,
          // signId:true,
          sex: true,
          // salaryCycle:true,
          searchType: true,
        })
        if (jumpPage != 'jumpPage') {
          this.PromotersPopUp.pageNo = 1
        }
        this.tableLoading = true;
        this.$http({
          method: "POST",
          url: "/rest/PublishedWork/searchSalesmans",
          data: {
            name: this.PromotersPopUp.name,
            idcard: this.PromotersPopUp.idCard,
            ageMin: this.PromotersPopUp.minAge,
            ageMax: this.PromotersPopUp.maxAge,
            heightMin: this.PromotersPopUp.minHeight,
            heightMax: this.PromotersPopUp.maxHeight,
            empCode: this.PromotersPopUp.empCode,
            pageNo: this.PromotersPopUp.pageNo,
            pageSize: this.PromotersPopUp.pageSize,
            projectStartTime: this.plan.startTime,
            dto: {
              // crescoreMin: this.jobInformation.scoreIntervalStart,
              crescoreMin: null,
              // crescoreMax: this.jobInformation.scoreIntervalEnd,
              crescoreMax: null,
              searchType: idData.searchType,
              // searchType: 0,
              storeCode: this.storeCode,
              // rankRuleId: this.jobInformation.rankRuleId,
              // rankRuleId: null,
              sex: idData.sex
            }
          }
        }).then(res => {
          this.tableData = res.data.salesmanList;
          this.PromotersPopUp.total = res.data.countSize;
          this.tableLoading = false;

          //创建一个id数组，方便查询
          let salesManIds = []
          this.isckeckPromotersList2.map(item => {
            salesManIds.push(item.id)
          })
          //如果是在id数组中的，则选中
          setTimeout((salesManIds) => {
            this.tableData.map(item => {
              if (salesManIds.indexOf(item.id) > -1) {
                this.$refs.salesmuli.toggleRowSelection(item, true)
              }
            })
          }, 50, salesManIds)
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          this.tableLoading = false;
        });
      },
      //促销员2级页-单个删除
      deleteLabel(index) {
        this.isckeckPromotersList.splice(index, 1)
        if (this.isckeckPromotersList.length == 0) {
          this.checkedPromoters = false
        }
      },
      //选择促销员，2级进入3级
      choosePromoters() {
        //先重置
        this.tableData = [];
        this.PromotersPopUp.total = null;

        this.innerVisible = false;
        this.innerVisible2 = true;
        //把2级的数据复制给3级
        this.isckeckPromotersList2 = [];
        this.isckeckPromotersList.map(item => {
          this.isckeckPromotersList2.push(item)
        })
        //清空筛选项
        this.PromotersPopUp.name = null;
        this.PromotersPopUp.idCard = null;
        this.PromotersPopUp.minAge = null;
        this.PromotersPopUp.maxAge = null;
        this.PromotersPopUp.minHeight = null;
        this.PromotersPopUp.maxHeight = null;
        //之前进来就获取数据，现在要求进去后点筛选才搜索
        //然后筛选
        // this.searchSaleManInfo('doNotJump');
      },
      //促销员3级页点击取消
      changeInnerVisible2() {
        this.innerVisible = true;
        this.innerVisible2 = false;
      },
      //促销员3级页点击确定
      sureSaleMan() {
        this.innerVisible = true;
        this.innerVisible2 = false;
        //把3级的数据复制给2级
        this.isckeckPromotersList = []
        this.isckeckPromotersList2.map(item => {
          this.isckeckPromotersList.push(item)
        })
      },
      //促销员3级页-table check或取消
      selectChange(selection, row) {
        // selection是所有选中的行，row是当前被点击的行
        let add = false;//如果是新增的则是true，否则是false
        selection.map(item => {
          if (row.id == item.id) {
            add = true
          }
        })
        if (add) {
          this.isckeckPromotersList2.push(row)
        } else {
          //这里用for循环break可以提高性能
          this.isckeckPromotersList2.map((item, index, arr) => {
            if (row.id == item.id) {
              arr.splice(index, 1)//只删一次，所以可以用arr + splice
            }
          })
        }
        // console.log(selection,row)
      },
      //促销员3级页-table 全选或取消
      selectAllChange(selection) {
        //如果是全选中
        if (selection.length == this.tableData.length) {
          let ids = []
          this.isckeckPromotersList2.map(item => {
            ids.push(item.id)
          })
          selection.map(item => {
            if (ids.indexOf(item.id) < 0) {
              this.isckeckPromotersList2.push(item)
            }
          })
        } else {
          //如果是“取消全选”
          let delArr = []
          this.tableData.map(item => {
            this.isckeckPromotersList2.map((item2, index) => {
              if (item.id == item2.id) {
                delArr.unshift(index)
              }
            })
          })
          delArr.map(item => {
            this.isckeckPromotersList2.splice(item, 1)
          })
        }
      },
      //促销员3级页面-单个促销员删除
      deleteLabel2(index) {
        let item = this.isckeckPromotersList2[index]
        this.tableData.map(item1 => {
          if (item.id == item1.id) {
            this.$refs.salesmuli.toggleRowSelection(item1, false);
          }
        }, 0)
        this.isckeckPromotersList2.splice(index, 1)
      },
      //促销员3级页面-更改页面大小
      handleSizeChange(value) {
        this.PromotersPopUp.pageSize = value;
        this.searchSaleManInfo('doNotJump');
      },
      //促销员3级页面-更改页码
      handleCurrentChange(value) {
        this.PromotersPopUp.pageNo = value;
        this.searchSaleManInfo('jumpPage');
      },


      /*
      推送管理标签分3级，注意数据互通的逻辑
      1级：array123
      2级：SignArr
      3级：SignArr2
      贯通级：SignPopUp,主要用于第3级
      */
      //推送管理（2级）点击选择标签弹出3级
      chooseSign() {
        this.innerVisible = false;
        this.innerVisible3 = true;
        //把2级页的标签数据配给3级
        let arr = this.SignArr
        let arr2 = this.SignArr2
        let ids = {
          arr1: [],
          arr2: [],
          arr3: []
        }
        let SignPopUp = this.SignPopUp
        for (let i = 1; i < 4; i++) {
          //先置空，再重新push
          arr2['array_' + i] = []
          arr['array_' + i].map(item => {
            arr2['array_' + i].push(item);
            ids['arr' + i].push(item.id)
          })
          let x
          if (i == 1) {
            x = ''
          } else {
            x = i
          }
          SignPopUp['tabsData' + x].map(item => {
            if (ids['arr' + i].indexOf(item.id) != -1) {
              item.choose = true
            } else {
              item.choose = false
            }
          })
        }
        //标签3级页的下拉框设定，放在全部数据加载完成之后
        //这个函数在本组件生命周期内只执行一次
        if (this.onceTime) {
          setTimeout(() => {
            var arr = document.getElementsByClassName('signWrap')
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].offsetHeight < 50) {
                arr[i].nextElementSibling.setAttribute("style", "display:none;")
              }
            }
            this.onceTime = false;
          }, 100)
        }
      },
      //推送管理(2级)，删除标签
      removeSignLabel(index, type) {
        let obj = this.SignArr
        obj['array_' + type].splice(index, 1)
        if(obj.array_1.length == 0 &&
          obj.array_2.length == 0 &&
          obj.array_3.length == 0){
          this.checkedSign = false
        }
      },
      //添加标签（3级），确定
      sureSignLabel() {
        this.innerVisible = true;
        this.innerVisible3 = false;

        let arr2 = this.SignArr2
        let arr = this.SignArr
        for (let i = 1; i < 4; i++) {
          arr['array_' + i] = [];
          arr2['array_' + i].map(item => {
            arr['array_' + i].push(item)
          })
        }
      },
      //添加标签（3级），点击取消
      changeInnerVisible3() {
        this.innerVisible = true;
        this.innerVisible3 = false;
      },
      //选择标签的3个函数，其实都类似，就指向不同，那天心情好了给合并下
      hangYeChoose(item) {
        var arr = [];
        item.choose = !item.choose
        if (item.choose) {
          // 如果是不限，则取消所有勾选，如果不是则取消'不限'的勾选
          if (item.id == -2) {
            this.SignPopUp.tabsData.map(item1 => {
              item1.choose = false
            });
            item.choose = true
          } else {
            //否则取消不限
            this.SignPopUp.tabsData[0].choose = false
          }
        }
        this.SignPopUp.tabsData.map(item1 => {
          if (item1.choose) {
            arr.push(item1);
          }
        });
        this.SignArr2.array_1 = arr;
      },
      gangWeiChoose(item) {
        var arr = [];
        item.choose = !item.choose
        if (item.choose) {
          // 如果是不限，则取消所有勾选，如果不是则取消'不限'的勾选
          if (item.id == 0) {
            this.SignPopUp.tabsData2.map(item1 => {
              item1.choose = false
            });
            item.choose = true
          } else {
            this.SignPopUp.tabsData2.map(item1 => {
              if (item1.id == 0) {
                item1.choose = false
              }
            });
          }
        }
        this.SignPopUp.tabsData2.map(item1 => {
          if (item1.choose) {
            arr.push(item1);
          }
        });
        this.SignArr2.array_2 = arr;
      },
      biaoQianChoose(item) {//自我标签
        var arr = [];
        item.choose = !item.choose
        if (item.choose) {
          // 如果是不限，则取消所有勾选，如果不是则取消'不限'的勾选
          if (item.id == -3) {
            this.SignPopUp.tabsData3.map(item1 => {
              item1.choose = false
            });
            item.choose = true
          } else {
            this.SignPopUp.tabsData3[0].choose = false
          }
        }
        this.SignPopUp.tabsData3.map(item1 => {
          if (item1.choose) {
            arr.push(item1);
          }
        });
        this.SignArr2.array_3 = arr;
      },
      //选择标签的清除函数
      removeArray(x) {
        this.SignArr2['array_' + x] = [];
        if (x == 1) {
          x = ''
        }
        this.SignPopUp['tabsData' + x].map(item => {
          item.choose = false;
        });
      },
      //推送管理（2级），点击推送
      levelTwoSubmit() {
        var idData = this.transDataToId({
          scheduleType: true,
          rankRuleId: true,
          signId: true,
          sex: true,
          salaryCycle: true,
          searchType: true,
        })
        //点再次推送的时候已经校验过了，这里不再校验表单
        //推送方式
        var postType = null;
        let checkSign = this.checkedSign
        let checkPromoter = this.checkedPromoters
        if (checkPromoter && checkSign) {//都选了
          postType = 0
        } else if (!checkPromoter && !checkSign) {//都没选
          postType = 1
        } else if (!checkPromoter && checkSign) {//仅选标签推送
          postType = 2
        } else if (checkPromoter && !checkSign) {//仅选促销员推送
          postType = 3
        }

        var errMsg2 = '';
        //推送是否选了内容
        if (postType == 1) {
          errMsg2 = '推送方式不能为空！'
        } else if (checkPromoter && this.isckeckPromotersList.length == 0) {
          errMsg2 = '请选择至少一个促销员！'
        } else if (checkSign && this.SignArr.array_1.length == 0 && this.SignArr.array_2.length == 0 && this.SignArr.array_3.length == 0) {
          errMsg2 = '请选择至少一个标签！'
        }
        if (errMsg2 != '') {
          this.myNotify(this, 'warning', errMsg2)
          return false
        }

        let PromotersList = []

        this.isckeckPromotersList.map(item => {
          PromotersList.push(item.id)
        })

        let signList = []
        let SignArr = this.SignArr
        SignArr.array_1.map(item => {
          signList.push(item.id)
        })
        SignArr.array_2.map(item => {
          signList.push(item.id)
        })
        SignArr.array_3.map(item => {
          signList.push(item.id)
        })
        //数据准备好了，发请求
        this.posLoading = true
        this.$http({
          method: "POST",
          url: "/rest/PostManagement/onceAgainPublish",
          data: {
            posStoreId: this.dataList.posStoreId,
            workPosId: this.Child[0].workPosId,
            posName: this.jobInformation.jobName,
            signId: idData.signId,
            customer: this.jobInformation.serviceObj,
            scheduleType: idData.scheduleType,
            posDetail: this.jobInformation.jobDescription,
            salaryDetail: this.jobInformation.salaryTreatment,
            welfareDetail: this.jobInformation.postWelfare,
            requirements: this.jobInformation.jobRequirements,
            salaryCycle: idData.salaryCycle,
            salary: this.jobInformation.monthSalary,
            salaryType: Number(this.jobInformation.salary),
            moName: this.jobInformation.supervisorName,
            moTel: this.jobInformation.supervisorTel,
            requirementsTel: this.jobInformation.contactMethod,
            searchType: idData.searchType,
            signIdList: (postType == 2 || postType == 0) ? signList : [],
            salesmanIdList: (postType == 3 || postType == 0) ? PromotersList : [],
            publishUserId: sessionStorage.getItem('sysUserId'),
            rankRuleId: idData.rankRuleId,
            sex: idData.sex,
            // workCode: "string",
            requirementsStart: this.plan.startTime,
            requirementsEnd: this.plan.endTime,
            recruitsNumber: this.plan.applyNumber,
            remark: this.plan.Remarks,
            postType: postType,
            planNumber: this.plan.number,

            /*crescoreMax: this.jobInformation.scoreIntervalEnd,*/
            crescoreMin: this.jobInformation.scoreIntervalStart,
            storeCode: this.storeCode,

            otherPosDetail: this.jobInformation.otherPosDetail,
            otherRequirements: this.jobInformation.otherRequirements,
          }
        }).then(res => {
          this.posLoading = false;

          if (res.data.message != '发布失败') {
            this.innerVisible = false
            console.log('this.innerVisible', this.innerVisible)
            this.myNotify(this, 'success', "推送成功")
            // window.location.reload()
            this.$emit('submitForm')//成功后后台数据变了，但页面上的数据不会变更，主动触发父级的‘筛选’按钮事件，以更新视图
            setTimeout(() => {//这个方法可能优先级高
              this.$emit("upupup", false); //主动触发upup方法，'hehe'为向父组件传递的数据，这里将销毁此对象，所以必须放在最后一行
            }, 10)
          } else {
            this.myNotify(this, 'error', res, '发布失败，请稍后重试')
          }
        }).catch(err => {
          this.posLoading = false;
          this.myNotify(this, 'error', err.response, '发布失败，请稍后重试')
        });
      },
      //标签3级，展开收起所有标签
      toggleSlide(event) {
        let target = event.target;
        let parentNode = target.parentNode.previousElementSibling;
        if (parentNode.offsetHeight > 45) {
          target.className = "toggle-btn";
          parentNode.style.height = 45 + "px";
        } else {
          target.className = "toggle-btn up";
          parentNode.style.height = "auto";
        }
      },

      checkBoxValue(val, type) {
        var self = this
        var v = ''
        if (type == '任务说明') {
          v = self.taskInstructionsSigns1V.join(";")
          self.jobInformation.posDetail = v
          if (!self.taskInstructionsSigns1V.includes('其他')) {
            self.jobInformation.otherPosDetail = ''
          }
        }else if(type == '任务要求') {
          v = self.taskInstructionsSigns2V.join(";")
          self.jobInformation.requirements = v
          if (!self.taskInstructionsSigns2V.includes('其他')) {
            self.jobInformation.otherRequirements = ''
          }
        }
        console.log('--------->',v);
      },
      // 获取任务说明
      getTaskInstructionsSigns() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchTaskDescriptionRequirements?type=1',
        }).then(res => {
          let data = res.data
          this.taskInstructionsSigns1 = data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 获取任务要求
      getTaskInstructionsSigns2() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchTaskDescriptionRequirements?type=2',
        }).then(res => {
          let data = res.data
          this.taskInstructionsSigns2 = data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
    },
    watch: {
      dataReady: {
        handler: function (newVal, oldVal) {
          if (
            newVal.getIndustryLabel &&
            newVal.getJobLabel &&
            newVal.getSelfLabel &&
            newVal.searchMasterName1 &&
            newVal.searchMasterName2 &&
            newVal.searchRankRuleName &&
            newVal.searchJudgeInterview
          ) {
            console.log('基础数据准备完毕')
            this.getData()
          }
        },
        deep: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .wrap {
    background-color: #f2f2f2;
    border-radius: 5px;
    margin-bottom: 10px;
    font-size: 14px !important;
    .title {
      padding: 5px 10px;
      border-bottom: 1px solid white;
    }
    .content {
      padding: 20px;
    }
  }

  .footer {
    background-color: #f8f8f8;
    border-top: 5px solid #f2f2f2;
    border-bottom: 5px solid #f2f2f2;
    border-radius: 5px;
    padding: 5px 20px;
    .title {
      padding-bottom: 5px;
      border-bottom: 1px solid white;
    }
  }

  .formSty {
    //   display: flex;
    justify-content: space-around;
    margin: 0 0px 12px 0px;
    .half:nth-child(1) {
      float: left;
      width: 45%;
    }
    .half:nth-child(2) {
      float: right;
      width: 45%;
    }
    .formArea:nth-child(1) {
      float: left;
      width: 45%;
    }
    .formArea:nth-child(2) {
      float: right;
      width: 45%;
    }
  }

  .formInp {
    width: 50%;
    float: left;
  }

  .formLabel {
    display: block;
    width: 80px;
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 27px;
    padding: 0 12px 0 0;
  }

  .formInpWid {
    width: 55%;
  }

  .required {
    color: #f6914b;
  }

  .rangeSetting {
    width: 90px;
  }

  .rangeSetting1 {
    width: 90px;
  }

  .rangeSetting .el-input__inner {
    background: #f8f8f8;
  }

  .body .el-row {
    // border: 1px solid;
    padding: 10px 5px;
  }

  .clickSign {
    background-color: #81bc82;
    padding: 3px 15px;
    border-radius: 30px;
    color: white;
  }

  .already-btn {
    background-color: #8299dc;
    color: white;
    padding: 3px 10px;
    border-radius: 30px;
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
  }

  .remove-btn {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-left: 20px;
    margin-top: -2px;
    background: url(../../common/images/shan2.png) no-repeat center;
  }

  .PromotersDialog .formLabel {
    width: 70px;
  }

  .rangeSettingAge {
    width: 50px;
  }

  .search {
    height: 30px;
    width: 50px;
    text-align: center;
    line-height: 30px;
    color: white;
    background-color: #2d2c78;
    border-radius: 5px;
    float: right;
    cursor: pointer;
  }

  .tableBackGround {
    padding: 10px;
    background-color: #f4f4f4;
  }

  .label-tabs .el-checkbox {
    background: #f8f8f8;
    border-color: #eaeaea;
  }

  .label-tabs .el-checkbox.is-bordered.is-checked {
    background: #8299dc;
  }

  .label-tabs .el-checkbox.is-bordered.is-checked .el-checkbox__label {
    color: #fff;
  }

  .label-tabs .el-checkbox .el-checkbox__input {
    display: none;
  }

  .signList {
    padding: 5px 10px;
    background-color: #f8f8f8;
    border: 1px solid #e3e3e3;
    border-radius: 5px;
    color: #646464;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .toggle-btn {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 6px;
    right: 0;
    background-image: url(../../common/images/11zhankai.png);
    background-repeat: no-repeat;
    background-position: top left;
    z-index: 99;
    &.up {
      background-image: url(../../common/images/12shouqi.png);
    }
  }

  .active {
    background-color: #8198db;
    border-color: #8198db;
    color: white;
  }

  .search-btn {
    width: 90px;
    margin-left: 30px;
    margin-right: 30px;
  }

  .reset-btn {
    width: 90px;
  }

  .formLabel.pad20 {
    padding-right: 20px
  }
</style>



// WEBPACK FOOTER //
// src/views/workSquare/postEdit.vue